import DOMPurify from 'dompurify';
import IllumioSupportUtils from "./common/support_utils.js";

const IllumioDocumentationArchivesTOC = {
    $tables: null,
    hashChangeHandler: function() {
    	const selectedVersion = location.hash.slice(1);
        if (IllumioDocumentationArchivesTOC.$tables && selectedVersion) {
            VersionSelection.changeVersionSelection(selectedVersion);
            IllumioDocumentationArchivesTOC.$tables.each(function(index, element) {
                if (element.id==selectedVersion) {
                    element.classList.remove('hide');
                    element.classList.remove('hidden');
                } else {
                    element.classList.add('hidden');
                }
            });
            IllumioSupportUtils.triggerResizeUIEvent();
        }
    },
    loadTocSuccessHandler: function(data, textStatus, jqXHR) {
        // console.debug(data);
        // console.debug(textStatus);
        // console.debug(jqXHR);
        
        const theContent = document.getElementById('theDocumentationArchivesContent');
        const sanitizedFragment = DOMPurify.sanitize(data, {
            RETURN_DOM_FRAGMENT: true
        });
        theContent.replaceChildren(sanitizedFragment);

        document.querySelectorAll('#theDocumentationArchivesContent .hide').forEach((element) => {
            element.classList.add('hidden');
            element.classList.remove('hide');
        });
        
        const versions = [];
        IllumioDocumentationArchivesTOC.$tables = $('#illumioDocumentationIndex > div');
        IllumioDocumentationArchivesTOC.$tables.each(function(index, element) {
            const parts = element.id.split('-');
            if (parts.length<3) {
                return;
            }

            if (parts[2].match(/^1/) || parts[0].match(/xpress/i)) {
                element.classList.add('hidden');
                return;
            }
            versions.push({product: parts[0], version: parts[2]});
            
            const tableElement = document.createElement('table');
            tableElement.id = element.id;
            tableElement.classList.add('ilo-tabular');
            tableElement.classList.add('hidden');
            tableElement.style.width = '100%';

            const theRows = element.children;
            let headingStart = -1;
            for (let i=0;i<theRows.length;i++) {
                /** Example: 
                    <div id="msp-version-22.51" class="ilo-tabular">
                        <div class="row heading">
                            <div class="small-16 columns">Version 22.51</div>
                        </div>
                        <div class="row last">
                            <div class="medium-10 large-12 columns">PDF Archive</div>
                            <div class="medium-2 large-1 columns hide-for-small-only"></div>
                            <div class="medium-4 large-3 columns"><a href="/documentation/22.51/Illumio_MSP_22.51_PDFs.zip">Zip</a></div>
                        </div>
                    </div>
                    */
                if (theRows[i].classList.contains('heading')) {
                    headingStart = i;

                    const thElement = document.createElement('th');
                    thElement.setAttribute('colspan', '2');
                    thElement.textContent = theRows[i].children[0].textContent.trim();

                    const trElement = document.createElement('tr');
                    trElement.appendChild(thElement);

                    tableElement.appendChild(trElement);
                } else {
                    const labelElement = document.createElement('td');
                    labelElement.textContent = theRows[i].children[0].textContent.trim();

                    const linkElement = document.createElement('td');
                    linkElement.style.display = 'flex';
                    linkElement.style.justifyContent = 'flex-end';
                    linkElement.style.paddingRight = '2rem';
                    linkElement.appendChild(theRows[i].children[2].children[0]);

                    const trElement = document.createElement('tr');
                    trElement.appendChild(labelElement);
                    trElement.appendChild(linkElement);
                    tableElement.appendChild(trElement);
                }
            }
            element.replaceWith(tableElement);
        });
        IllumioDocumentationArchivesTOC.$tables = $('#illumioDocumentationIndex > table');
                
        if (versions.length>0) {
            versions.sort((a, b) => `${a.product}-${a.version}`.localeCompare(`${b.product}-${b.version}`));
            VersionSelection.populateOptions(versions);
        }
        IllumioDocumentationArchivesTOC.hashChangeHandler();

        const $theColumns = IllumioDocumentationArchivesTOC.$tables.find('.columns');
        $theColumns.each(function(index, element) {
            if (element.innerHTML.trim()=='' || element.innerHTML.trim()=='&nbsp;') {
                element.classList.add('hide-for-small-only');
            } 
        });
        
        // IllumioSupportTemplate.initializeNonHtmlPageViewTracking();
    },
    loadTocErrorHandler: function(jqXHR, textStatus, errorThrown) {
        console.debug(jqXHR);
        console.debug(errorThrown);
        console.debug(textStatus);
        
        const pElement = document.createElement('p');
        pElement.textContent = `We are sorry that the content is not loaded successfully. Please try again later. (${jqXHR.status})`;
        const theContent = document.getElementById('theDocumentationArchivesContent');
        theContent.replaceChildren(pElement);
    },
    initialize: function() {
        $.ajax({
            type: 'GET',
            url: '/documentation/index_toc.htm',
            contentType: 'text/html', 
            dataType: 'html', 
            success: this.loadTocSuccessHandler,
            error: this.loadTocErrorHandler,
        });
        window.onhashchange = IllumioDocumentationArchivesTOC.hashChangeHandler;
    }, 
}; 

const VersionSelection = {
    versions: null,
    versionSelection: null, 
    versionsSortHandler: function(a, b) {
        console.debug(a + ' vs ' + b);
    },
    onChangeHandler: function(event) {
        if (!event) {
            return;
        }
        
        const selectedVersion = event.currentTarget.options[event.currentTarget.selectedIndex].value;
        location.hash = selectedVersion;
    }, 
    populateOptions: function(versions) {
        this.versionSelection = document.getElementById('versionSelection');
        
        if (versions==null || versions.length<=0 || this.versionSelection.options.length>0) {
            return;
        }
        
        this.versions = versions;
        
        this.versionSelection.classList.add('select');
        this.versionSelection.onchange = this.onChangeHandler;
        this.versionSelection.style.display = 'inline';
        this.versionSelection.options.add(new Option('Select a Product Version', ''));
        const that = this;
        $(this.versions).each(function(index, element) {
            const text = `${IllumioSupportUtils.capitalizeWord(element.product)} Version ${element.version}`;
            const value = `${element.product}-version-${element.version}`;
            const option = new Option(text, value);
            if (location.hash.length>0 && location.hash=='#'+element) {
                option.selected = true;
            } 
            that.versionSelection.options.add(option);
        });
        
        if (this.versionSelection.options.length>1) {
            this.versionSelection.classList.remove('hide');
            let selectedOption = 1;
            if (location.hash.length>0) {
                for (let i=1;i<this.versionSelection.options.length;i++) {
                    if (`#${this.versionSelection.options[i].value}`===location.hash) {
                        selectedOption = i;
                    }
                }
            }
            this.versionSelection.options[selectedOption].selected = true;
            try {
                this.versionSelection.dispatchEvent(new Event('change'));
            } catch(err) {
                // Workaround for IE 
                if (navigator.userAgent.indexOf('MSIE ')>0 || navigator.userAgent.indexOf('Trident/')>0) {
                    const event = new Event('Event', {
                        bubbles: false,
                        cancelable: true
                    });
                    // const event = document.createEvent('Event');
                    // event.initEvent('change', false, true);
                    this.versionSelection.dispatchEvent(event);
                }    
            }
        }
    }, 
    changeVersionSelection: function(version) {
        if (VersionSelection.versionSelection && VersionSelection.versionSelection.options && version) {
            for (let i=0;i<VersionSelection.versionSelection.options.length;i++) {
                if (VersionSelection.versionSelection.options[i].value===version && VersionSelection.versionSelection.options[i].selected===false) {
                    VersionSelection.versionSelection.options[i].selected = true;
                }
            }
        } 
    } 
};

export default IllumioDocumentationArchivesTOC;
